export const convertNullToUndefined = <T>(value: T) =>
  value === null ? undefined : value

export const convertUndefinedToNull = <T>(value: T) =>
  value === undefined ? null : value

export const isNotUndefined = <T>(value: T | undefined): value is T =>
  value !== undefined
